import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-approved-header',
  templateUrl: './not-approved-header.component.html',
  styleUrls: ['./not-approved-header.component.scss']
})
export class NotApprovedHeaderComponent implements OnInit {
  @Input() notApproved: boolean;

  constructor() { }

  ngOnInit() {
  }

}
